import { ReactFlowProvider } from 'reactflow';
import type { GraphData, ProcessMapping, Stages } from '../../../api/process-client/process-client.type';
import type { ProcessScope } from '../../process/context/process.context.type';
import type { ViewType } from '../../process/process.type';
import { SectionGraph } from './section-graph';

type Props = {
  graphData: GraphData | undefined;
  mapping: ProcessMapping | null;
  viewType: ViewType;
  scope: ProcessScope;
  setScope: (scope: Partial<ProcessScope>) => void;
  stages: Stages[];
  isRightGraph: boolean;
};

export const ProcessGraph = ({ viewType, graphData, mapping, scope, setScope, stages, isRightGraph }: Props) => {
  return (
    <ReactFlowProvider>
      <div style={{ height: 'calc(100% - 20px)' }}>
        <SectionGraph
          graphData={graphData}
          mapping={mapping}
          viewType={viewType}
          scope={scope}
          setScope={setScope}
          stages={stages}
          isRightGraph={isRightGraph}
        />
      </div>
    </ReactFlowProvider>
  );
};
